import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=4287cb2f&scoped=true&"
import script from "./NewTag.vue?vue&type=script&lang=js&"
export * from "./NewTag.vue?vue&type=script&lang=js&"
import style0 from "./NewTag.vue?vue&type=style&index=0&id=4287cb2f&lang=scss&scoped=true&"
import style1 from "./NewTag.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4287cb2f",
  null
  
)

export default component.exports